<script lang="ts">
	import type { SbImage, SbVideo } from '../types';
	import SbRichtext from '../components/sbRichtext.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			asset: ISbStoryData<SbVideo | { image: SbImage }>[];
			title: ISbRichtext;
			subtitle: ISbRichtext;
			cta: ISbStoryData[];
			hero_height: number;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section
	use:editable={content}
	class="hero-height"
	style="--hero-height: {content.hero_height || 100}svh"
>
	<div class="h-full w-full lg:px-6 lg:pb-6">
		<div class="relative h-full w-full lg:overflow-hidden lg:rounded-[20px]">
			<Blok content={content.asset[0]} />
		</div>
	</div>
	<div
		class="absolute top-1/2 flex w-full -translate-y-1/2 flex-col items-center justify-center text-balance px-5 text-center text-stone-5 lg:px-32"
	>
		<div class="mx-auto max-w-[930px]">
			<h1 class="mb-3 text-[48px]/[96%] font-bold tracking-[-.48px] lg:mb-6 lg:text-[64px]/[100%]">
				<SbRichtext text={content.title} />
			</h1>
			<h2 class="mb-7 text-[18px]/[140%] lg:mb-16 lg:text-[26px]/[130%]">
				<SbRichtext text={content.subtitle} />
			</h2>
		</div>
		<Blok content={content.cta[0]} />
	</div>
</section>

<style lang="scss">
	.hero-height {
		height: var(--hero-height);

		@media (min-width: 1024px) {
			height: calc(100svh - var(--header-height) - var(--banner-height));
		}
	}
</style>
